<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.cnsuo" placeholder="功能名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.cnsuo" placeholder="功能code"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.cnsuo" placeholder="功能类型"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addCategory">增加</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="功能名称">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能code">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="值类型">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能点属性">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能类型">
        <template v-slot="scope">
          <span>{{ scope.row.describe }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editFun(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deleteFun(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增修改 -->
    <el-dialog title="新增/编辑主类目" v-model="dialogFormVisible" width="600px">
      <el-form :model="form">
        <el-form-item label="功能名称" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="功能code" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="功能" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="值类型" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="功能点属性" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="功能类型" label-width="100px">
          <el-input v-model="form.name" type="text" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="addconfirm">新增</el-button>
          <el-button type="primary" v-if="edit" @click="editconfirm">修改</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        cnsuo: '',
        cocn: '',
      },
      list: [
        {describe: '一个毛栗子'}
      ],
      dialogFormVisible: false,
      form: {

      },
      edit: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    addCategory () {
      this.edit = false
      this.dialogFormVisible = true
    },
    editFun(item) {
      if (item) {
        this.edit = true
      } else {
        this.edit = false
      }
      this.dialogFormVisible = true
    },
    deleteFun(item) {
      this.$confirm('是否删除该功能?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    addconfirm () {

    },
    editconfirm () {

    },
  },
  filters: {},
  mounted () { },
  created () { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
